import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslatorService } from '@app/core/translator/translator.service';
import { IS1InputSelectItem } from '@app/s1';
import { OperationsCheckService } from '@app/shared/services/operationsCheck.service';

@Component({
    selector: 'mdm-input-luogo-select',
    templateUrl: './input-luogo-select.component.html',
    styleUrl: './input-luogo-select.component.scss',
    standalone: false
})
export class InputLuogoSelectComponent implements OnInit, OnDestroy {

    @Input() label: string;
    @Input() control: UntypedFormControl;

    @Output() onSelectClear = new EventEmitter();
    @Output() onSelectChange = new EventEmitter();

    options: IS1InputSelectItem[] = [];
    languageChangedSubscription: any;

    constructor(private operationsCheckService: OperationsCheckService,private translator: TranslatorService) {}

    ngOnInit(): void {
        this.getLuoghiCq();
        this.languageChangedSubscription = this.translator.languageChanged.subscribe(() => {
            this.getLuoghiCq();
        });
    }

    getLuoghiCq() {
        this.operationsCheckService.getLuoghiCq().subscribe(luoghi => {
            let label = this.translator.getLanguageInUse() === 'it' ? 'nameIt' : 'nameEn';
            this.options = luoghi.map(l => ({ code: l.id, label: l[label] } as IS1InputSelectItem));
        });
    }

    cleared() {
        this.onSelectClear.emit();
    }

    changed(event) {
        this.onSelectChange.emit(event);
    }

    ngOnDestroy(): void {
        this.languageChangedSubscription.unsubscribe();
    }

}
